// @ts-nocheck
import { TransactionHistoryTableOptions } from '@tassat/fred-extended-definitions';

import { TransactionHistoryAgGrid } from './transactionHistoryAgGrid';

export interface TransactionHistoryAgGridProps {
    tableOptions: TransactionHistoryTableOptions;
    setSelectedTransactionId: React.Dispatch<React.SetStateAction<string>>;
    overlayOpen?: boolean;
}

export default TransactionHistoryAgGrid;